import { render, staticRenderFns } from "./GiftActions.vue?vue&type=template&id=3036c4bb&"
import script from "./GiftActions.vue?vue&type=script&lang=ts&"
export * from "./GiftActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports